import React from "react";
import './Apoio.css'
//imagens
import Dimen from '../campos/imagens/apoiadores/10D.jpg'
import Dart from '../campos/imagens/apoiadores/Deart.jpg'
import ect from '../campos/imagens/apoiadores/Ect.jpg'
import emu from '../campos/imagens/apoiadores/Emu.jpg'
import prox from '../campos/imagens/apoiadores/Proex.jpg'
import nac from '../campos/imagens/apoiadores/nac.jpg'
import Mlab from '../campos/imagens/apoiadores/MediaLab.png'
import Nlab from '../campos/imagens/apoiadores/NatalNet.png'
import Uf from '../campos/imagens/apoiadores/ufrn.jpg'
import prope from '../campos/imagens/apoiadores/prope.jpg'
import PPGPC from '../campos/imagens/apoiadores/ppgpc.png'
import ufg from '../campos/imagens/apoiadores/ufg.png'
/**
 *10 D 
DEART ECT EM ( ordem alfabética)
NAC PROEX PROPESQ

Natalnet Media Lab PPGPC/Performances Culturais

 */
function Apoio(){
    return(
        <>  
            <div className="sozin">
                <img src={Dimen}/>
            </div>
            <div className="marcas">
                <img src={Dart}/>
                <img src={ect}/>
                <img src={emu}/>
            </div>
            <div className="marcas">
                <img src={nac}/>
                <img src={prox}/>
                <img src={prope}/>
            </div>
            <div className="marcas">
                <img src={Nlab}/>
                <img src={Mlab}/>
                <img src={PPGPC}/>
            </div>
            <div className="marcas">
                <img src={Uf}/>
                <img src={ufg}/>
            </div>
        </>

        
)}

export default Apoio;